frappe.ready(function() {
    // Override cart display to show count and total
    function updateCartDisplay() {
        const cart_count = frappe.get_cookie("cart_count");
        const cart_total = frappe.get_cookie("cart_total");
        const $badge = $("#cart-count");
        const $cart = $(".cart-icon");

        // If no cart count or zero, don't show anything extra
        if (!cart_count || parseInt(cart_count) === 0) {
            return;
        }

        // Ensure cart icon is visible
        if ($cart.length) {
            $cart.css("display", "inline");
            $(".shopping-cart").removeClass("hidden");
        }

        if ($badge.length) {
            if (cart_total) {
                // Decode the cookie value (handles URL encoding)
                const decoded_total = decodeURIComponent(cart_total);
                $badge.html(`${cart_count} | ${decoded_total}`);
            } else {
                // No cart_total cookie yet - fetch from server
                frappe.call({
                    method: "webshop.webshop.shopping_cart.cart.get_cart_quotation",
                    type: "GET",
                    async: true,
                    callback: function(r) {
                        if (r.message && r.message.doc) {
                            const total = r.message.doc.grand_total || 0;
                            // Format with dollar sign
                            const formatted = "$" + parseFloat(total).toFixed(2);
                            $badge.html(`${cart_count} | ${formatted}`);
                        }
                    }
                });
            }
        }
    }

    // Override set_cart_count if webshop is available
    function setupCartOverride() {
        if (typeof webshop !== 'undefined' && webshop.webshop && webshop.webshop.shopping_cart) {
            const original_set_cart_count = webshop.webshop.shopping_cart.set_cart_count;

            webshop.webshop.shopping_cart.set_cart_count = function(animate = false) {
                // Call original function first
                original_set_cart_count.call(this, animate);
                // Then update with our custom display after a short delay
                // to allow cookies to be set
                setTimeout(updateCartDisplay, 50);
            };
        }
    }

    // Initial setup - try immediately and with delay for robustness
    function initCartDisplay() {
        setupCartOverride();
        updateCartDisplay();
    }

    // Run immediately
    initCartDisplay();

    // Also run with delays to handle slow loading
    setTimeout(initCartDisplay, 100);
    setTimeout(initCartDisplay, 500);

    // Brand domains mapping
    const brandDomains = {
        "esse.cslshoes.com": "Esse Comfort",
        "wizfort.cslshoes.com": "Wizfort Shoes",
        "benelaccio.cslshoes.com": "Benelaccio",
        "essecomfort.com": "Esse Comfort",
        "wizfort.com": "Wizfort Shoes",
        "benelaccio.com": "Benelaccio"
    };
    
    const currentHost = window.location.host.replace("www.", "");
    
    // If on a brand-specific site, hide the brand filter
    if (brandDomains[currentHost]) {
        // Wait for filters to load
        const observer = new MutationObserver(function() {
            const brandFilter = document.querySelector('.filter-block:has(.filter-label:contains("Brand"))');
            if (!brandFilter) {
                // Try alternative selector
                const filterLabels = document.querySelectorAll('.filter-label');
                filterLabels.forEach(label => {
                    if (label.textContent.trim().toUpperCase() === 'BRAND') {
                        label.closest('.filter-block, .mb-4, div').style.display = 'none';
                    }
                });
            }
        });
        
        observer.observe(document.body, { childList: true, subtree: true });
        
        // Also try immediately
        setTimeout(() => {
            const filterLabels = document.querySelectorAll('.filter-label, .uppercase');
            filterLabels.forEach(label => {
                if (label.textContent.trim().toUpperCase() === 'BRAND') {
                    label.closest('.mb-4, .filter-block')?.remove();
                }
            });
        }, 1000);
    }
});
